import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { VALIDATION } from "../../constants/validation";
import { checkPhotographerExistence } from "../../api/photographer";
import { updatePhotographerProfile } from "../../api/photographer";
import SubHeader from "../../components/SubHeader";
import ProfileImage from "../../components/ProfileImage";
import Types from "../../components/Types";
import Location from "../../components/Location";
import ButtonActive from "../../components/ButtonActive";
import InputButtonBox from "../../components/InputButtonBox";

export default function EditPhotographerProfile() {
  const navigate = useNavigate();
  const location = useLocation();

  const [userInfo, setUserInfo] = useState<any>();
  const [mainPhotographyTypes, setMainPhotographyTypes] = useState<string[]>(
    []
  );
  const [activeRegions, setActiveRegions] = useState<string[]>([]);

  const [isValid, setIsValid] = useState(false);
  const [isChangedName, setIsChangedName] = useState(false);
  const [isValidName, setIsValidName] = useState(true);
  const [isDuplicated, setIsDuplicated] = useState("");

  useEffect(() => {
    if (!location.state) return;
    setUserInfo(location.state);
    setMainPhotographyTypes(location.state.mainPhotographyTypes ?? []);
    setActiveRegions(location.state.activeRegions ?? []);
    // 마운트 시 location.state에서 수정할 초기값을 1회 설정
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      isDuplicated !== "true" &&
      mainPhotographyTypes.length > 0 &&
      activeRegions.length > 0
    )
      setIsValid(true);
    else setIsValid(false);
  }, [isDuplicated, userInfo, mainPhotographyTypes, activeRegions]);

  const handleNameInput = (e: any) => {
    setIsDuplicated("");
    setIsChangedName(true);

    let value = e.target.value;
    value = value.replace(/^\s+/, "").replace(/\s+/g, " ");

    if (location.state?.nickname === value) setIsChangedName(false);
    setUserInfo({ ...userInfo, nickname: value });

    setIsValidName(
      value.length >= VALIDATION.NICKNAME_PHOTOGRAPHER.MIN &&
        value.length <= VALIDATION.NICKNAME_PHOTOGRAPHER.MAX &&
        VALIDATION.NICKNAME_PHOTOGRAPHER.REGEX.test(value)
    );
  };

  const checkExistence = async () => {
    if (!isValidName) return;
    let formatted = userInfo.nickname.replace(/\s+$/, "");
    try {
      setUserInfo({ ...userInfo, nickname: formatted });
      const res = await checkPhotographerExistence(formatted);
      if (res.exists) setIsDuplicated("true");
      else setIsDuplicated("false");
    } catch (e) {
      console.log(e);
    }
  };

  const onClickSave = async () => {
    const { nickname, profileImage } = userInfo;
    try {
      await updatePhotographerProfile({
        nickname,
        profileImage,
        mainPhotographyTypes,
        activeRegions,
      });
    } catch (e) {
      console.log(e);
    } finally {
      navigate(`/mypage`, { replace: true });
    }
  };

  if (!userInfo) return <></>;
  return (
    <div className="relative flex flex-col gap-6 px-4">
      <SubHeader title="프로필 수정" />
      <div className="flex flex-col gap-8 mb-20">
        <ProfileImage userInfo={userInfo} setUserInfo={setUserInfo} />
        <div>
          <InputButtonBox
            isRequired={true}
            title="상호/활동명"
            description=""
            placeholder="상호명을 입력해주세요."
            onChange={handleNameInput}
            onClick={() => checkExistence()}
            activation={
              isValidName && isChangedName && isDuplicated !== "false"
            }
            buttonTitle="중복 확인"
            bottomText=""
            value={userInfo.nickname}
            isReadOnly={false}
          />
          {isDuplicated === "" ? (
            <div
              className={`text-xs ${
                isValidName && userInfo.nickname.length > 0
                  ? "text-textgray"
                  : "text-red"
              }`}
            >
              {`한글, 영어, 숫자, 공백 조합 ${VALIDATION.NICKNAME_PHOTOGRAPHER.MAX}자 이내`}
            </div>
          ) : (
            <div
              className={`text-xs ${isDuplicated === "true" ? "text-red" : "text-violet500"}`}
            >
              {isDuplicated === "true"
                ? "중복된 상호/활동명입니다"
                : "사용 가능한 상호/활동명입니다."}
            </div>
          )}
        </div>
        <Types
          types={mainPhotographyTypes}
          setTypes={setMainPhotographyTypes}
          maxNum={3}
        />
        <Location locs={activeRegions} setLocs={setActiveRegions} maxNum={5} />
      </div>
      <ButtonActive
        activation={isValid}
        onClick={() => onClickSave()}
        text="확인"
      />
    </div>
  );
}
